(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chexz-bottom-nav"] && !Shopify.designMode) return;
  try {
    window.chexzOpenCart = function() {
    // The dialog lifecycle is owned by <theme-drawer>, not by <cart-drawer-component>.
    var drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
    window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
  };

  window.chexzOpenSearch = function() {
    var modal = document.getElementById('search-modal');
    if (modal && typeof modal.showDialog === 'function') { modal.showDialog(); return; }
    window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'search';
  };

  document.addEventListener('cart:update', function(e) {
    var count = e.detail && e.detail.data && e.detail.data.itemCount;
    if (count === undefined && e.detail && e.detail.resource) count = e.detail.resource.item_count;
    if (count === undefined) return;
    var badge = document.querySelector('.sh-bnav__badge');
    var wrap = document.querySelector('.sh-bnav__cart-wrap');
    if (count > 0 && wrap) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'sh-bnav__badge';
        wrap.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["chexz-lang-switcher"] && !Shopify.designMode) return;
  try {
    (function () {
  document.querySelectorAll('[data-sh-lang-trigger]').forEach(function (btn) {
    var wrapper = btn.closest('.sh-lang');
    var dropdown = wrapper.querySelector('[data-sh-lang-dropdown]');

    /* Toggle on button click */
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = wrapper.hasAttribute('data-open');
      /* Close all others first */
      document.querySelectorAll('.sh-lang[data-open]').forEach(function (el) {
        el.removeAttribute('data-open');
        el.querySelector('[data-sh-lang-trigger]').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        wrapper.setAttribute('data-open', '');
        btn.setAttribute('aria-expanded', 'true');
      }
    });

    /* Close on outside click */
    document.addEventListener('click', function () {
      wrapper.removeAttribute('data-open');
      btn.setAttribute('aria-expanded', 'false');
    });

    /* Close on Escape */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        wrapper.removeAttribute('data-open');
        btn.setAttribute('aria-expanded', 'false');
        btn.focus();
      }
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cl-brand-index"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cl-brand-filter')) {
    /**
     * Filters the brand index by the text typed in its search field.
     */
    class ClBrandFilter extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-cl-input]');
        this.empty = this.querySelector('[data-cl-empty]');
        this.input?.addEventListener('input', this.#filter);
      }

      disconnectedCallback() {
        this.input?.removeEventListener('input', this.#filter);
      }

      /** @param {string} value */
      static normalize(value) {
        return value.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
      }

      #filter = () => {
        const query = ClBrandFilter.normalize(this.input?.value ?? '');
        let shown = 0;
        for (const group of this.querySelectorAll('[data-cl-group]')) {
          let groupShown = 0;
          for (const item of group.querySelectorAll('[data-cl-name]')) {
            const match = !query || ClBrandFilter.normalize(item.getAttribute('data-cl-name') ?? '').includes(query);
            item.hidden = !match;
            if (match) groupShown++;
          }
          group.hidden = groupShown === 0;
          shown += groupShown;
        }
        if (this.empty) this.empty.hidden = shown > 0;
      };
    }
    customElements.define('cl-brand-filter', ClBrandFilter);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cl-product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.clProductCardReady) return;
    window.clProductCardReady = true;

    /* The wishlist heart ([data-cl-wish]) is handled by assets/cl-delight.js, which owns the shared
       wishlist store, the header count, the heart burst and the wishlist drawer. */

    /** @param {HTMLButtonElement} button */
    const addToCart = async (button) => {
      if (typeof window.chexzCartAdd !== 'function') return;
      button.disabled = true;
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
      try {
        // flyFrom: assets/cl-delight.js flies this card's image into the header bag before the drawer opens.
        await window.chexzCartAdd(
          { id: button.dataset.clAdd, quantity: 1 },
          { source: button.dataset.source, flyFrom: button }
        );
        button.classList.add('is-added');
        setTimeout(() => button.classList.remove('is-added'), 1600);
      } catch (error) {
        /* the cart bridge already reports the error to the theme */
      } finally {
        button.disabled = false;
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      }
    };

    document.addEventListener('click', (event) => {
      const target = /** @type {HTMLElement} */ (event.target);
      if (!(target instanceof Element)) return;

      const add = /** @type {HTMLButtonElement | null} */ (target.closest('[data-cl-add]'));
      if (!add || add.disabled) return;
      event.preventDefault();
      addToCart(add);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
